"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_menu_1 = tslib_1.__importStar(require("rc-menu"));
var config_provider_1 = require("../../config-provider");
var Sider_1 = require("../../layout/Sider");
var motion_1 = tslib_1.__importDefault(require("../../util/motion"));
var reactNode_1 = require("../../util/reactNode");
var MenuContext_1 = tslib_1.__importDefault(require("./MenuContext"));
var MenuItem_1 = tslib_1.__importDefault(require("./MenuItem"));
var SubMenu_1 = tslib_1.__importDefault(require("./SubMenu"));
require("./style");
var InternalMenu = /** @class */ (function (_super) {
    tslib_1.__extends(InternalMenu, _super);
    function InternalMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.renderMenu = function (_a) {
            var _b;
            var getPopupContainer = _a.getPopupContainer, getPrefixCls = _a.getPrefixCls, direction = _a.direction;
            var _c = _this.props, customizePrefixCls = _c.prefixCls, className = _c.className, theme = _c.theme, expandIcon = _c.expandIcon;
            var defaultMotions = {
                horizontal: { motionName: 'slide-up' },
                inline: motion_1.default,
                other: { motionName: 'zoom-big' },
            };
            var prefixCls = getPrefixCls('menu', customizePrefixCls);
            var menuClassName = (0, classnames_1.default)("".concat(prefixCls, "-").concat(theme), (_b = {},
                _b["".concat(prefixCls, "-inline-collapsed")] = _this.getInlineCollapsed(),
                _b), className);
            return (React.createElement(MenuContext_1.default.Provider, { value: {
                    inlineCollapsed: _this.getInlineCollapsed() || false,
                    antdMenuTheme: theme,
                    prefixCls: prefixCls,
                    direction: direction,
                } },
                React.createElement(rc_menu_1.default, tslib_1.__assign({ getPopupContainer: getPopupContainer }, _this.props, { className: menuClassName, prefixCls: prefixCls, direction: direction, defaultMotions: defaultMotions, expandIcon: (0, reactNode_1.cloneElement)(expandIcon, {
                        className: "".concat(prefixCls, "-submenu-expand-icon"),
                    }) }))));
        };
        return _this;
    }
    InternalMenu.prototype.getInlineCollapsed = function () {
        var _a = this.props, inlineCollapsed = _a.inlineCollapsed, siderCollapsed = _a.siderCollapsed;
        if (siderCollapsed !== undefined) {
            return siderCollapsed;
        }
        return inlineCollapsed;
    };
    InternalMenu.prototype.render = function () {
        return React.createElement(config_provider_1.ConfigConsumer, null, this.renderMenu);
    };
    InternalMenu.defaultProps = {
        className: '',
        theme: 'light',
        mode: 'inline',
        focusable: false,
        inlineIndent: 24,
    };
    return InternalMenu;
}(React.Component));
// We should keep this as ref-able
var Menu = /** @class */ (function (_super) {
    tslib_1.__extends(Menu, _super);
    function Menu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Menu.prototype.render = function () {
        var _this = this;
        return (React.createElement(Sider_1.SiderContext.Consumer, null, function (context) { return React.createElement(InternalMenu, tslib_1.__assign({}, _this.props, context)); }));
    };
    Menu.Divider = rc_menu_1.Divider;
    Menu.Item = MenuItem_1.default;
    Menu.SubMenu = SubMenu_1.default;
    Menu.ItemGroup = rc_menu_1.ItemGroup;
    return Menu;
}(React.Component));
exports.default = Menu;
//# sourceMappingURL=index.js.map